import styled from "styled-components";

export const FormWrapper = styled.div`
  margin: 2rem;
`;

export const TextInput = styled.input`
  width: 18rem;
  height: 3rem;
  margin: 1rem;
`;

export const SelectWrapper = styled.div`
  &.invalid {
    border: ${(props) => props.theme.colors.ERROR_MESSAGE} solid 2px;
  }

  .region-selector {
    font-family: "Spartan", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    .region-selector__control {
      background-color: ${(props) => props.theme.colors.INPUT_BACKGROUND};
      height: 3rem;
    }

    .region-selector__indicator-separator {
      width: 0;
    }

    .region-selector__option--is-focused {
      background-color: ${(props) => props.theme.colors.LINK_COLOR};
    }

    .region-selector__option--is-selected {
      background-color: ${(props) => props.theme.colors.LINK_COLOR_DARKENED};
    }
  }
`;

export const SupportMessageContainer = styled.div`
  color: #18182d;
  text-align: center;
  margin-top: 1.8rem;

  a {
    color: ${(props) => props.theme.colors.LINK_COLOR};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    color: white;
    margin: 0;
  }
`;

export const SelectErrorWrapper = styled.div`
  height: 1rem;
  span {
    display: block;
    margin-top: 0.5rem;
    color: ${(props) => props.theme.colors.ERROR_MESSAGE};
    font-size: 0.9rem;
    font-weight: 600;
    text-align: left;
  }
`;

export const ErrorWrapper = styled.div`
  height: 1rem;
  width: 16rem;
  margin-top: 1rem;

  span {
    display: block;
    margin-top: 0.5rem;
    color: ${(props) => props.theme.colors.ERROR_MESSAGE};
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
  }
`;
